import { createFileRoute } from '@tanstack/react-router';
import { loadVapiSdk, VAPI_PUBLIC_KEY, VAPI_ASSISTANT_ID, VAPI_TOOLS } from '@/lib/vapi';

export const Route = createFileRoute('/api/public/vapi-init-debug')({
  component: () => null
});

// This is just to ensure the file is valid and can be imported if needed
export const debugVapiInit = async () => {
  console.log("[VAPI_INIT_TRACE] Manual debug triggered");
  const vapi = await loadVapiSdk();
  console.log("[VAPI_INIT_TRACE] SDK Loaded:", !!vapi);
  if (vapi?.run) {
     console.log("[VAPI_INIT_TRACE] vapi.run exists");
  }
};
